import { jwtDecode } from 'jwt-decode';

/** Single storage key for the JWT — import this instead of string literals. */
export const AUTH_TOKEN_STORAGE_KEY = 'authToken';

/** Seconds of leeway for `exp` vs device clock skew (common on mobile). Server still enforces JWT. */
const CLOCK_SKEW_LEEWAY_SEC = 300;

export const getToken = () => {
  return localStorage.getItem(AUTH_TOKEN_STORAGE_KEY);
};

export const isTokenValid = () => {
  const token = getToken();
  if (!token) return false;

  try {
    const decoded = jwtDecode(token);
    if (decoded.exp == null || typeof decoded.exp !== 'number') {
      return false;
    }
    const currentTime = Date.now() / 1000;
    return decoded.exp > currentTime - CLOCK_SKEW_LEEWAY_SEC;
  } catch (error) {
    console.error('Invalid token', error);
    return false;
  }
};

export const saveToken = (token) => {
  localStorage.setItem(AUTH_TOKEN_STORAGE_KEY, token);
};

export const logOut = () => {
  localStorage.removeItem(AUTH_TOKEN_STORAGE_KEY);
};
